export default __webpack_public_path__ + "static/media/77.62a3cfc6.png";